import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../default-settings-service.service';

@Component({
  selector: 'app-audit-item-small',
  templateUrl: './audit-item-small.component.html',
  styles: []
})
export class AuditItemSmallComponent extends ExcTranslation implements OnInit {

  @Input('data') data;
  constructor(private excDss: DefaultSettingsService) {
    super();
  }
  showLinkArrow() {
    if (this.data.LinkLevel === undefined || this.data.LinkLevel === null) {
      return false;
    }
    if (this.data.LinkIsLast === false) {
      return true;
    }
    return false;
  }
  getLinkedClass() {
    if (this.data.LinkLevel !== undefined && this.data.LinkLevel !== null && this.data.LinkLevel === 0) {
      return 'ch-gray';
    }
  }
  getAvatarTooltip() {
    let t = '';
    t = this.getGlobal('AuditType_' + this.data.AuditType);
      if ((this.data.AuditType === 35 || this.data.AuditType === 16) && this.data.AuditPartialResults === true) {
        t = t + ' (' + this.getGlobal('PartialResults') + ')';
    }
    return t;
    // switch (this.data.AuditType) {
    //   case 16:
    //     t = this.getGlobal('Selfcheck');
    //     break;
    //   case 30:
    //   case 31:
    //   case 32:
    //     t = this.getGlobal('Pauschalkredit');
    //     break;
    //   case 33:
    //     t = this.getGlobal('Videocheck');
    //     break;
    //   case 34:
    //     t = this.getGlobal('Geofence');
    //     break;
    //   case 3:
    //     t = this.getGlobal('Termin48');
    //     break;
    //   default:
    //     t = this.getGlobal('Floorcheck');
    //     break;
    // }
    // if (this.data.AuditIsPicked === true) {
    //   t = t + ' (' + this.getGlobal('Picked') + ')';
    // }
    // return t;
  }
  getAvatarClass() {
    let cls = '';
    switch (this.data.AuditType) {
      case 16:
        cls = 'fa-mobile';
        break;
      case 30:
      case 31:
      case 32:
        cls = 'fa-sack-dollar';
        break;
      case 33:
        cls = 'fa-video';
            break;
      case 34:
        cls = 'fa-satellite';
        break;
      case 3:
        cls = 'fa-user-shield';
        break;
      case 35:
        cls = 'fa-scanner-image';
        break;
      case 36:
        cls = 'fa-user-clock';
        break;
      default:
        cls = 'fa-user-secret';
        break;
    }
    if (this.data.AuditType === 16 || this.data.AuditType === 35) {
      if (this.data.AuditPartialResults === true) {
        cls = cls + ' th-danger';
      } else {
        if (this.data.AuditIsPicked === true) {
          cls = cls + ' th-warning';
        } else {
          cls = cls + ' th-secondary';
        }
      }
    } else {
      if (this.data.AuditIsPicked === true) {
        cls = cls + ' th-warning';
      } else {
        cls = cls + ' th-secondary';
      }
    }
    return cls;
    // if (this.data.AuditType === 16) {
    //   if (this.data.AuditIsPicked) {
    //     return 'fa-mobile th-warning';
    //   } else {
    //   return 'fa-mobile th-secondary';
    //   }
    // } else {
    //   if (this.data.AuditIsPicked) {
    //     return 'fa-user-secret th-warning';
    //   } else {
    //     return 'fa-user-secret th-secondary';
    //   }
    // }
  }
  getAttractorTip() {
    if (this.data.AuditType === 16 || this.data.AuditType === 35) {
      switch (this.data.AuditStatus) {
        case 1:
        case 2:
        case 3:
          return this.getGlobal('Planned');
        case 8:
        case 9:
          if (this.data.ScRejected === true) {
            return this.getGlobal('Rejected');
          } else {
            if (this.data.ScEnded === true) {
              return this.getGlobal('Done');
            } else {
              return this.getGlobal('Expired');
            }
          }
        case 10:
          return this.getGlobal('Cancelled');
      }
    } else {
      switch (this.data.AuditStatus) {
        case 1:
          return this.getGlobal('Created');
        case 2:
          return this.getGlobal('Assigned');
        case 3:
          return this.getGlobal('Planned');
        case 4:
        case 5:
        case 6:
        case 7:
          return this.getGlobal('InProgress');
        case 8:
        case 9:
          return this.getGlobal('Done');
        case 10:
          return this.getGlobal('Cancelled');
      }
    }
  }
  getAttractorClass() {
    if (this.data.AuditType === 16 || this.data.AuditType === 35) {
      switch (this.data.AuditStatus) {
        case 1:
        case 2:
        case 3:
          return 'ch-secondary fa-calendar';
        case 8:
        case 9:
          if (this.data.ScRejected === true) {
            return 'ch-danger fa-exclamation';
          } else {
            if (this.data.ScEnded === true) {
              return 'ch-success fa-check';
            } else {
              return 'ch-warning fa-clock';
            }
          }
        case 10:
          return 'ch-warning fa-ban';
      }
    } else {
      switch (this.data.AuditStatus) {
        case 1:
          return 'ch-secondary fa-asterisk';
        case 2:
          return 'ch-secondary fa-user';
        case 3:
          return 'ch-secondary fa-calendar';
        case 4:
        case 5:
        case 6:
        case 7:
          return 'ch-secondary fa-cogs';
        case 8:
        case 9:
          return 'ch-success fa-check';
        case 10:
          return 'ch-warning fa-ban';
      }
    }
  }

  ngOnInit() {
  }

}
